import $ from "jquery";
let Welcome_Modal;

let noun_modal;

noun_modal = require("./noun_modal");

Welcome_Modal = (() => {
    function Welcome_Modal() {
        $(".modal-overlay").on("click", e => noun_modal.dismiss());
        $(".modal-overlay .inner").on("click", e => e.stopPropagation());
    }

    return Welcome_Modal;
})();

export default Welcome_Modal;
